import React, {useEffect} from 'react';
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

export const PrivateRoute = ({ children, allowedRoles }) => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      const currentPath = window.location.pathname;

      if (currentPath.startsWith("/detalhes-material")) {
        return;
      }

      if (currentPath.startsWith("/aprovador-engenheiro")) {
        return;
      }

      if (user.roles.includes("KEYCLOAK_REALM_ROLE: TAX")) {
        navigate("/home-tax");
      } else if (user.roles.includes("KEYCLOAK_REALM_ROLE: ENGINEER")) {
        navigate("/home-engenheiro");
      } else {
        navigate("/unauthorize");
      }
    }
  }, [user]);

  if (loading) {
    return <div>Carregando autenticação...</div>;
  }
  if (
    !user &&
    (window.location.pathname === "/login" || window.location.pathname === "/")
  )
    return children;

  if (!user) {
    return <Navigate to="/unauthorize" />;
  }

  return children;
};
